export const en = {
  title: 'Model capabilities',
  refresh: 'Refresh',
  addModel: 'Add model',
  addModelUnavailable: 'Add a capability connection before adding models.',
  addVoiceUnavailable: 'Add an enabled TTS model before adding voices.',
  edit: 'Edit',
  enable: 'Enable',
  disable: 'Disable',
  setCurrent: 'Set as current',
  saved: 'Configuration saved.',
  filters: { allProviders: 'All providers' },
  types: { text: 'Text', image: 'Image', video: 'Video', tts: 'TTS', embedding: 'Embedding' },
  sections: { text: 'Text models', image: 'Image models', video: 'Video models', tts: 'TTS models', embedding: 'Embedding models' },
  status: { enabled: 'Enabled', disabled: 'Disabled', current: 'Current', standby: 'Standby' },
  table: { model: 'Model', provider: 'Provider', status: 'Status', productionModel: 'Production model', dimensions: 'Dimensions' },
  pricing: {
    ranges: { title: 'Input range', all: 'All', upTo: '≤ {value}', between: '{from}–{to}', above: '> {value}' },
    headers: { input: 'Input / 1M tokens', output: 'Output / 1M tokens', cached: 'Cached / 1M tokens', cacheWrite: 'Cache write / 1M tokens', image: 'Price / image', withVideo: 'With video / 1M tokens', withoutVideo: 'Without video / 1M tokens', tts: 'Price / 10k characters' },
  },
  modelForm: {
    create: 'Add model',
    edit: 'Edit model',
    imagePrice: 'Price per image (CNY)',
    videoWithInputPrice: 'Per million tokens with video input (CNY)',
    videoWithoutInputPrice: 'Per million tokens without video input (CNY)',
    ttsPrice: 'Per 10k characters (CNY)',
    embeddingPrice: 'Per million tokens (CNY)',
    dimensions: 'Vector dimensions',
    dimensionsHint: 'Fixed once created. A different dimension is a different vector space — add another model and switch the route instead.',
  },
  voiceTypes: { native: 'Native', clone: 'Cloned' },
  voices: {
    title: 'Voice catalog',
    add: 'Add voice',
    name: 'Display name',
    id: 'Voice ID',
    type: 'Type',
    model: 'Default model',
    resource: 'Resource ID',
    expressiveModel: 'Expressive model',
  },
  voiceForm: { create: 'Add voice', edit: 'Edit voice' },
  voiceProfile: {
    language: 'Language', profile: 'Voice profile', gender: 'Gender presentation', age: 'Perceived age', styles: 'Style tags', stylesHint: 'Warm, calm, authoritative', description: 'Voice description',
    genderOptions: { feminine: 'Feminine', masculine: 'Masculine', neutral: 'Neutral' },
    ageOptions: { young_adult: 'Young adult', adult: 'Adult', mature: 'Mature', senior: 'Senior' },
  },
}

export const zh = {
  title: '模型能力管理',
  refresh: '刷新',
  addModel: '新增模型',
  addModelUnavailable: '需要先新增对应的模型能力接入。',
  addVoiceUnavailable: '需要先新增并启用 TTS 模型。',
  edit: '编辑',
  enable: '启用',
  disable: '停用',
  setCurrent: '设为当前模型',
  saved: '配置已保存。',
  filters: { allProviders: '全部厂商' },
  types: { text: '文本', image: '图片', video: '视频', tts: 'TTS', embedding: '向量' },
  sections: { text: '文本模型', image: '图片模型', video: '视频模型', tts: 'TTS 模型', embedding: '向量模型' },
  status: { enabled: '已启用', disabled: '已停用', current: '当前生产', standby: '备用' },
  table: { model: '模型', provider: '厂商', status: '状态', productionModel: '生产模型', dimensions: '维度' },
  pricing: {
    ranges: { title: '输入区间', all: '全部', upTo: '≤ {value}', between: '{from}–{to}', above: '> {value}' },
    headers: { input: '输入 / 百万 tokens', output: '输出 / 百万 tokens', cached: '缓存 / 百万 tokens', cacheWrite: '缓存写入 / 百万 tokens', image: '单价 / 张', withVideo: '有视频输入 / 百万 tokens', withoutVideo: '无视频输入 / 百万 tokens', tts: '单价 / 万字符' },
  },
  modelForm: {
    create: '新增模型',
    edit: '编辑模型',
    imagePrice: '单张图片价格（元）',
    videoWithInputPrice: '有视频输入每百万 tokens（元）',
    videoWithoutInputPrice: '无视频输入每百万 tokens（元）',
    ttsPrice: '每万字符价格（元）',
    embeddingPrice: '每百万 tokens（元）',
    dimensions: '向量维度',
    dimensionsHint: '建好之后不可修改。换维度就是换向量空间，请新增一个模型再切路由。',
  },
  voiceTypes: { native: '原生音色', clone: '复刻音色' },
  voices: {
    title: '音色目录',
    add: '新增音色',
    name: '运营名称',
    id: '音色 ID',
    type: '音色类型',
    model: '默认模型',
    resource: '资源 ID',
    expressiveModel: '表达力模型',
  },
  voiceForm: { create: '新增音色', edit: '编辑音色' },
  voiceProfile: {
    language: '语言', profile: '音色画像', gender: '声音性别倾向', age: '声音年龄感', styles: '风格标签', stylesHint: '温柔、冷静、权威', description: '音色说明',
    genderOptions: { feminine: '偏女性', masculine: '偏男性', neutral: '中性' },
    ageOptions: { young_adult: '青年', adult: '成年', mature: '中年', senior: '老年' },
  },
}
